// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7NMuI","name":"Header_name__1YUSK","birthday":"Header_birthday__1xUYb","skeleton":"Header_skeleton__3lagp"};